// react-router's own bookkeeping: idx stays 0 until this document pushes an entry, which a
// redirect never does.
export function hasSomewhereToGoBack(): boolean {
  return ((window.history.state as { idx?: number } | null)?.idx ?? 0) > 0;
}
